import { get } from "lodash";
import USER_TYPE_CONSTANTS from "@/constants/user";

const isFilled = value => !["", null, undefined].includes(value);

export const getUserAccessProfile = ({
  decodedToken,
  internalUser,
  bioteSalesUser,
  selectedVendor,
}) => {
  const userMeta = get(decodedToken, "sim.user", {});
  const userType = userMeta.userType;
  const subject = userMeta.subject;

  const isInternalUser = Boolean(internalUser);
  const isBioteSalesUser = Boolean(bioteSalesUser);
  const isSuperAdmin = Boolean(get(decodedToken, "sim.simpatraAdmin", false));
  const hasAdminPrivileges = isSuperAdmin || isInternalUser;

  const isVendorUser = userType === USER_TYPE_CONSTANTS.vendorUser;
  const isOrganizationUser = userType === USER_TYPE_CONSTANTS.organizationUser;
  const hasVendorView = isFilled(selectedVendor);

  const canAccessProviderFeatures =
    (!isInternalUser && (isOrganizationUser || isSuperAdmin)) ||
    isBioteSalesUser;
  const canAccessVendorFeatures = isVendorUser || hasAdminPrivileges;

  return {
    userType,
    subject,
    isInternalUser,
    isBioteSalesUser,
    isSuperAdmin,
    hasAdminPrivileges,
    isVendorUser,
    isOrganizationUser,
    hasVendorView,
    canAccessProviderFeatures,
    canAccessVendorFeatures,
  };
};

export const canAccessProviderFeatures = accessProfile =>
  accessProfile.canAccessProviderFeatures;

export const canAccessAdminFeatures = accessProfile =>
  accessProfile.hasAdminPrivileges;
